import { Box, IconButton, Modal, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import React from 'react';
import { FlexBoxBetween } from '../../../components/tableItems';

interface WeeklyLogNoteModalProps {
  open: boolean;
  closeModal: () => void;
  children: React.ReactNode;
  title: string;
  width?: number;
  maxHeight?: number;
  hideExit?: boolean;
}

const WeeklyLogModalParent: React.FC<WeeklyLogNoteModalProps> = ({
  open,
  closeModal,
  children,
  title,
  width,
  maxHeight,
  hideExit,
}) => {
  const style = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: width ?? 450,
    bgcolor: 'background.paper',
    maxHeight: maxHeight ?? 'auto',
    overflowY: maxHeight ? 'scroll' : 'auto',
    borderRadius: '7px',
    boxShadow: 24,
    px: 3,
    pt: 2,
    pb: 3,
  };
  return (
    <Modal open={open}>
      <Box sx={style}>
        <>
          <FlexBoxBetween>
            <Box />
            <Typography
              fontWeight={700}
              fontSize={17}
              textAlign="center"
              textTransform="capitalize"
            >
              {title}
            </Typography>
            {hideExit ? (
              <div />
            ) : (
              <IconButton
                disabled={false}
                onClick={closeModal}
                sx={{ fontSize: 17 }}
              >
                <CloseIcon fontSize="inherit" />
              </IconButton>
            )}
          </FlexBoxBetween>

          <Box mt={2.5}>{children}</Box>
        </>
      </Box>
    </Modal>
  );
};

export default WeeklyLogModalParent;
